import { apiResponse, defaultAgent } from "../helpers/web-agent";
import { tokenExpired } from "./auth";
import { toastError, toastSuccess } from "./toast";
import { FARM_NOTIFICATION, FARM_NOTIFICATION_REQUEST, NOTIFICATION_CONFIG_SAVING } from "../constants/action-types";
import { FARM_NOTIFICATION_UPDATED, FARM_NOTIFICATION_UPDATE_FAILED } from "../constants/messages";

export const farmNotificationRequest = (data) => ({ type: FARM_NOTIFICATION_REQUEST, payload: data });

export const notificationConfigSaving = (data) => ({ type: NOTIFICATION_CONFIG_SAVING, payload: data });

export const farmNotification = data => ({ type: FARM_NOTIFICATION, payload: data });

export const getFarmNotification = (farmId, cb) => dispatch => {
    dispatch(farmNotificationRequest(true));
    defaultAgent.get(`api/farm/notification`, farmId).then(res => {
        const agentResult = apiResponse(res, {});
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
            if (cb) cb(null);
        } else if (agentResult.data) {
            dispatch(farmNotification(agentResult.data));
            if (cb) cb(agentResult.data);
        }
        else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            if (cb) cb(null);
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
        if (cb) cb(null);
    });
};

export const updateFarmNotification = (params, cb) => dispatch => {
    dispatch(notificationConfigSaving(true));
    defaultAgent.put('/api/farm/notification', params)
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(FARM_NOTIFICATION_UPDATE_FAILED.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === FARM_NOTIFICATION_UPDATED.code) {
                dispatch(notificationConfigSaving(false));
                dispatch(toastSuccess(agentResult.message));
                if (cb) cb();
            } else dispatch(toastError(FARM_NOTIFICATION_UPDATE_FAILED.message));
        }).catch(ex => {
            dispatch(toastError(ex.message));
            cb && cb();
        });
};